"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");

var PromotionPerformanceExportRowExtensionConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PromotionPerformanceExportRowExtensionConverter, _DataObjectConverter_);

  function PromotionPerformanceExportRowExtensionConverter() {
    _classCallCheck(this, PromotionPerformanceExportRowExtensionConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionPerformanceExportRowExtensionConverter).apply(this, arguments));
  }

  return PromotionPerformanceExportRowExtensionConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PromotionPerformanceExportRowExtensionConverter = PromotionPerformanceExportRowExtensionConverter;